var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPushinMonsterCactus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 109.9,
    height: 282.97,
    viewBox: "0 0 109.9 282.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M63.96,1.79c-14,4.34-9.61,162.72-9.61,162.72,0,0-29.75,4.09-34.24-.4s3.75-74.99-1.5-80.86c-4.46-4.98-12.57-4.05-14.49,4.9-.55,2.58-6.79,77,2.18,84.04,8.97,7.05,47.41,4.48,47.41,4.48l6.41,101.86s0,1.92,7.05,2.56c7.05,.64,9.61,.64,13.45-1.92l3.84-2.56-2.56-42.28s12.81,1.92,17.94-2.56c5.13-4.48,11.53-50.61,7.05-58.94-4.48-8.33-12.81-6.41-14.09,1.28-1.28,7.69,1.28,43.56-1.92,44.85s-9.61,2.56-9.61,2.56c0,0-4.75-200.41-7.43-212.33-1.34-5.99-5.44-8.63-9.87-7.41Z",
    style: {
      fill: "#6e8478",
      stroke: "#231f20",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushinMonsterCactus);
export default __webpack_public_path__ + "static/media/pushin-monster-cactus.c1e1ef2ac584b5b04dd80a15334a6a10.svg";
export { ForwardRef as ReactComponent };